import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube, Twitter } from 'lucide-react';
import { contact, navLinks } from '../mock';
import LionLogo from './LionLogo';

export default function Footer() {
  return (
    <footer className="bg-[#1a1108] text-[#f7e6c2] pt-16 pb-6 relative overflow-hidden grain">
      <div className="container-x grid md:grid-cols-4 gap-10 relative z-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <LionLogo size={46} variant="gold" />
            <div>
              <div className="font-display text-lg font-bold">Etawah Lion Safari</div>
              <div className="text-[11px] uppercase tracking-widest text-[#c9a35c]">Uttar Pradesh · India</div>
            </div>
          </div>
          <p className="text-sm text-[#c9a35c] leading-relaxed">
            A pioneering wildlife conservation reserve dedicated to the majestic Asiatic Lion and India’s diverse fauna.
          </p>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            {navLinks.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-[#c9a35c] hover:text-[#f0b040] transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-[#c9a35c]">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 flex-shrink-0 text-[#f0b040]" /> {contact.address}</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4">Follow Us</h4>
          <div className="flex gap-3">
            {[Facebook, Instagram, Youtube, Twitter].map((Icon, i) => (
              <a key={i} href="#" className="w-10 h-10 rounded-full border border-[#5c4020] flex items-center justify-center text-[#c9a35c] hover:bg-[#b8791c] hover:text-[#1a1108] hover:border-[#b8791c] transition-all">
                <Icon size={18} />
              </a>
            ))}
          </div>
          <p className="mt-6 text-xs text-[#8b6520]">Sign up for park updates & safari news.</p>
          <div className="mt-3 flex">
            <input type="email" placeholder="Your email" className="bg-[#2b1d0e] text-sm px-3 py-2 rounded-l border border-[#5c4020] flex-1 focus:outline-none focus:border-[#b8791c]" />
            <button className="bg-[#b8791c] hover:bg-[#9a6314] text-[#1a1108] font-semibold px-4 rounded-r text-sm transition-colors">Join</button>
          </div>
        </div>
      </div>

      <div className="container-x mt-12 pt-6 border-t border-[#3d2a12] relative z-10">
        <p className="text-center text-xs text-[#c9a35c] leading-relaxed max-w-4xl mx-auto">
          This is a Registered Private Travel Agency under the name of <span className="text-[#f0b040] font-semibold">"Baba Siddhnath"</span> which organizes Etawah Lion Safari Tour Packages.
        </p>
        <p className="text-center text-xs text-[#8b6520] mt-2">
          © Copyright 2019 etawahlionsafari.com – All rights reserved.
        </p>
      </div>
    </footer>
  );
}
